import { t } from "../../utils/i18n";
import React from "react";
import paypalLogo from "../../../assets/images/payment_networks/paypal.png";
import cashappLogo from "../../../assets/images/payment_networks/cashapp.png";
import coinbaseLogo from "../../../assets/images/payment_networks/coinbase.png";
import binanceLogo from "../../../assets/images/payment_networks/binance.png";
import kucoinLogo from "../../../assets/images/payment_networks/kucoin.png";
import robinhoodLogo from "../../../assets/images/payment_networks/robinhood.png";

const BlockchainTransfer = ({
  blockchainAddress,
  validationErrors,
  selectedCurrency,
  handleBlockchainAddressChange,
  showModal
}) => (
  <>
    <div className="form-group row required recipient">
      <div className="row ml-2">
        <label className="form-label">{t("transfers_send.common.to")}</label>
      </div>
      <div className="input-group mb-2">
        <input
          step="any"
          autoFocus="autofocus"
          style={{ maxWidth: "400px" }}
          className={`form-control font-0_9 ${
            validationErrors?.blockchainAddressError ? "is-invalid" : ""
          }`}
          required="required"
          placeholder={t("transfers_send.common.payment_network_placeholder")}
          type="text"
          value={blockchainAddress}
          onChange={e => handleBlockchainAddressChange(e)}
        />
        <div className="input-group-append border border-dark">
          <span className="input-group-text border-0 mx-0 px-0">
            <a
              href="#"
              role="button"
              className="btn btn-link pull-left border-0"
              data-toggle="modal"
              onClick={() => showModal()}
            >
              <i className="fa fa-book "></i>{" "}
            </a>
          </span>
        </div>
      </div>
      {validationErrors?.blockchainAddressError && (
        <div className="error text-danger">
          <br />
          {validationErrors.blockchainAddressError}
        </div>
      )}
      <div id="amountHelpBlock" className="form-text text-muted mb-4 font-0_8">
        {t("transfers_send.common.wallet_address_help", { currency: selectedCurrency })}
      </div>
      <br />
      <div className="payment-networks">
        <img src={paypalLogo} width="60" className=" pl-2 pr-2" />
        <img src={cashappLogo} width="110" className="pl-2 pr-2" />
        <img src={coinbaseLogo} width="100" className="pl-2 pr-2" />
        <img src={binanceLogo} width="70" className="pl-2 pr-2" />
        <img src={kucoinLogo} width="70" className="pl-2 pr-2" />
        <img src={robinhoodLogo} width="100" className="pl-2 pr-2" />
        <span style={{ width: 40 }} className="pl-2 pr-2">
          <strong>
            <i className="fa fa-qrcode fa-2x "></i>
          </strong>
        </span>
      </div>

      <div className="alert alert-warning font-0_9 pt-2">
        <p>
          <i className="fa fa-exclamation-circle"></i> {t("transfers_send.common.avoid_loss", { currency: selectedCurrency })}
          {selectedCurrency == "OPAIG" && <span> {t("transfers_send.common.on_polygon")} </span>}
        </p>
      </div>
      <br />
    </div>
  </>
);

export default BlockchainTransfer;
